import { useRef, useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { Landmark, CreditCard } from "lucide-react";

const ICONS = [Landmark, CreditCard];

export default function PaymentMethods() {
    const { t } = useLanguage();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setIsVisible(true);
            },
            { threshold: 0.2 }
        );
        const current = sectionRef.current;
        if (current) observer.observe(current);
        return () => {
            if (current) observer.unobserve(current);
        };
    }, []);

    return (
        <section
            id="formas-de-pago"
            className="py-20 md:py-32 px-6"
            ref={sectionRef}
            data-testid="payment-section"
        >
            <div className="max-w-4xl mx-auto">
                <div
                    className="text-center mb-12"
                    style={{
                        opacity: isVisible ? 1 : 0,
                        transform: isVisible ? "translateY(0)" : "translateY(24px)",
                        transition: "opacity 0.6s ease, transform 0.6s ease",
                    }}
                >
                    <h2 className="text-3xl md:text-4xl font-semibold tracking-tight">
                        {t.payment.title}
                    </h2>
                    <p className="mt-4 text-base md:text-lg text-slate-500 dark:text-slate-400 max-w-2xl mx-auto">
                        {t.payment.subtitle}
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {t.payment.methods.map((method, i) => {
                        const Icon = ICONS[i];
                        return (
                            <div
                                key={i}
                                className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-8 text-center hover:border-blue-400/50 dark:hover:border-blue-500/50 transition-all duration-300 hover:shadow-md"
                                data-testid={`payment-method-${i}`}
                                style={{
                                    opacity: isVisible ? 1 : 0,
                                    transform: isVisible ? "translateY(0)" : "translateY(24px)",
                                    transition: `opacity 0.5s ease ${0.15 + i * 0.15}s, transform 0.5s ease ${0.15 + i * 0.15}s`,
                                }}
                            >
                                <div className="w-14 h-14 rounded-xl bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center mx-auto mb-5">
                                    <Icon className="w-7 h-7 text-blue-600 dark:text-blue-400" />
                                </div>
                                <h3 className="text-lg font-semibold mb-2">{method.title}</h3>
                                <p className="text-sm text-slate-500 dark:text-slate-400">{method.desc}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
